module.exports = __webpack_public_path__ + "img/trasn-stats.f9135cbe.png";